import React, { createContext, useReducer } from 'react';

type ContextType = {
  state: StateType;
  dispatch: React.Dispatch<IAction>;
};

type StateType = {
  user: User | null;
  loading: boolean;
};

const initialState: StateType = {
  user: null,
  loading: true,
};

const reducer = (state: StateType, action: IAction) => {
  switch (action.type) {
    case 'SET_USER':
      const { user } = action.payload;
      return { ...state, user, loading: false };
    case 'UPDATE_PHOTO_URL':
      const { photoUrl } = action.payload;
      return { ...state, photoUrl };
    case 'UPDATE_DISPLAY_NAME':
      const { displayName } = action.payload;
      return { ...state, user: { ...user, displayName }, loading: false };
    case 'LOG_OUT':
      return { ...state, user: null, loading: false };
    default:
      return state;
  }
};

const UserContext = createContext<ContextType>({
  state: { user: null, loading: true },
  dispatch: () => null,
});

export const Provider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {...initialState});
  return (
    <UserContext.Provider value={{ state, dispatch }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
